import URLS from './api';

export default [
`${URLS.login}`,
`${URLS.sendOtp}`,
`${URLS.verifyOtp}`,
`${URLS.setPassword}`,
`${URLS.refreshToken}`
]